'use strict'

define ['./referral.scss'], () ->
  ($rootScope, $scope, $http, $uibModal, Flash, RENTAPPLICATION_API_URL, affiliate_referrer) ->
    $scope.current_tab = 'pending'
    $scope.is_loading = false
    $scope.affiliate_referrer = affiliate_referrer
    $scope.referral_link = "#{$rootScope.HOST}/signup/#{$scope.affiliate_referrer.name}/"
    $scope.empty_state = !affiliate_referrer.activated
    $scope.num_agents = 8
    $scope.num_app = 65
    $scope.copied = false

    $scope.is_active_loading = false
    $scope.active_referrals = []
    $scope.active_current_page = 1
    $scope.active_total_count = 0
    $scope.active_total_page_count = 0

    $scope.is_pending_loading = false
    $scope.pending_referral_invites = []
    $scope.pending_current_page = 1
    $scope.pending_total_count = 0
    $scope.pending_total_page_count = 0

    $scope.$watch(() ->
      $scope.num_agents
    , (newVal, oldVal) ->
      if mixpanel and newVal != oldVal
        mixpanel.track('Interacted with Ambassador calculator')
    )

    $scope.$watch(() ->
      $scope.num_app
    , (newVal, oldVal) ->
      if mixpanel and newVal != oldVal
        mixpanel.track('Interacted with Ambassador calculator')
    )

    $scope.faqs = [{
      question: "Who can I refer to Rent Application?",
      answer: "Any real estate professional - real estate agent, independent landlord, or property manager -  who isn’t already a user of Rent Application."
    }, {
      question: "Is there a limit to how many people I can refer, or bonus I can accrue?",
      answer: "No! Your earning potential is unlimited. Use the calculator to estimate your income."
    }, {
      question: "When do I get credited for my referral?",
      answer: "Your account gets a commission each time your referral receives an application with a total cost that is greater than or equal to $49.95, excluding any additional MyPayments fees they add.\n\nFor example, you would earn a commission if your referral receives an application that includes Credit, Criminal, Eviction, and Employment reports."
    }, {
      question: "How much do I earn per commission?",
      answer: "Each time your referrals receive a qualifying application, you earn $20. For example, If they cumulatively receive 100 applications in a month, you earn $2,000 for the month."
    }, {
      question: "How many commissions can I earn per referral?",
      answer: "As many as your referral can generate in their first year as a customer with Rent Application. There’s no limit to the number of commissions you can earn per referral during that time. Commissions for a referral end 365 days after they join Rent Application."
    }, {
      question: "When can I expect my payout?",
      answer: "You can expect a payout to your bank account on the 15th of the month. A minimum balance of $200 is required for an automatic payout."
    }]

    # Clear any previous route's flash messages
    Flash.clear()

    if mixpanel
      mixpanel.track('View Ambassador Program page')

    $scope.toggleFaq = (index) ->
      $scope.faqs[index].open = !$scope.faqs[index].open
    
    $scope.load_active_referrals = (page = 1, filter = '') ->
      $scope.is_active_loading = true
      uri = "#{RENTAPPLICATION_API_URL}/api/v3/referrers/referrals/?page=#{page}" 

      if filter
        uri = uri + "&#{filter}=true"

      $http.get(uri)
        .then (resp) ->
          $scope.active_referrals = resp.data.results.map((r) ->
            r.days_left = 365 - moment().diff(r.date_joined, 'days')
            return r
          )
          $scope.active_current_page = page
          $scope.active_total_count = resp.data.count
          $scope.active_total_page_count = Math.ceil($scope.active_total_count / 25.0)
        .catch (err) ->
          console.log(err)
        .finally ->
          $scope.is_active_loading = false
    
    $scope.load_active_referrals()

    $scope.load_pending_referral_invites = (page = 1) ->
      $scope.is_pending_loading = true
      $http.get("#{RENTAPPLICATION_API_URL}/api/v3/referral_invites/?page=#{page}")
        .then (resp) ->
          $scope.pending_referral_invites = resp.data.results
          $scope.pending_current_page = page
          $scope.pending_total_count = resp.data.count
          $scope.pending_total_page_count = Math.ceil($scope.pending_total_count / 25.0)
        .catch (err) ->
          console.log(err)
        .finally ->
          $scope.is_pending_loading = false
    
    $scope.load_pending_referral_invites()

    $scope.paginate = (type, page) ->
      if type == 'pending'
        $scope.load_pending_referral_invites(page)
      else
        $scope.load_active_referrals(page)

    $scope.load_plaid = () ->
      if !window.Plaid
        plaidScript = document.createElement("script")
        plaidScript.src = "https://cdn.plaid.com/link/v2/stable/link-initialize.js"
        document.getElementsByTagName("head")[0].appendChild(plaidScript)
    
    $scope.load_plaid()

    $scope.see_breakdown = () ->
      $scope.load_active_referrals(1, 'current_balance_only')
      $scope.current_tab = 'active'
      el = document.getElementById('activity_table')
      el.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
      
    $scope.view_history = () ->
      $scope.load_active_referrals(1, 'commission_paid_history')
      $scope.current_tab = 'active'
      el = document.getElementById('activity_table')
      el.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})

    $scope.set_tab = (tab) ->
      $scope.current_tab = tab
    
    $scope.copy_link = () ->
      window.navigator.clipboard.writeText($scope.referral_link)
      $scope.copied = true
      if mixpanel
        mixpanel.track('Copied Ambassador Program invite link')
      setTimeout(() ->
        $scope.copied = false
        $scope.$apply()
      , 3000)
    
    $scope.open_invite_modal = () ->
      $uibModal.open
        template: require("./modals/invite.jade")
        controller: require("./modals/invite.coffee")
        windowClass: 'invite-modal'
        scope: $scope
      .result
      .then((result) ->
        if result
          if mixpanel
            mixpanel.track('Sent Ambassador Program invitation through modal')
          $scope.load_pending_referral_invites(1)
          Flash.create('success', 'Invitation sent!', 6000, { id: "referral", class: "text-center" })
      )
    
    $scope.open_connect_bank_account_modal = () ->
      $uibModal.open
        template: require("./modals/bank_account.jade")
        controller: require("./modals/bank_account.coffee")
        windowClass: 'bank-account-modal'
      .result
      .then((result) ->
        if result == 'plaid'
          $scope.open_plaid_link_modal()
        else if result == 'stripe'
          $scope.open_stripe_bank_modal()
      )
    
    $scope.open_plaid_link_modal = () ->
      $uibModal.open
        template: require("./modals/plaid_link.jade")
        controller: require("./modals/plaid_link.coffee")
        windowClass: 'plaid-link-modal'
      .result
      .then((result) ->
        $scope.start_plaid_link(result)
      )
    
    $scope.open_stripe_bank_modal = () ->
      $uibModal.open
        template: require("./modals/stripe_link.jade")
        controller: require("./modals/stripe_link.coffee")
        windowClass: 'stripe-link-modal'
      .result
      .then((result) ->
        if result
          $scope.create_bank_account(result)
      )
    
    $scope.open_verify_deposit_modal = () ->
      $uibModal.open
        template: require("./modals/verify_deposit.jade")
        controller: require("./modals/verify_deposit.coffee")
        windowClass: 'verify-deposit-modal'
      .result
      .then((result) ->
        if result
          $scope.affiliate_referrer = result
      )
    
    $scope.open_additional_info_modal = () ->
      $uibModal.open
        template: require("./modals/additional_info.jade")
        controller: require("./modals/additional_info.coffee")
        windowClass: 'additional-info-modal'
      .result
      .then((result) ->
        if result
          $scope.affiliate_referrer = result
      )

    $scope.start_plaid_link = (data) ->
      handler = window.Plaid.create({
        clientName: "Rentapplication powered by Plaid",
        token: data.link_token,
        product: ["auth"],
        onLoad: () ->
          console.log("Plaid loaded");
        ,
        onSuccess: (public_token, metadata) ->
          data.plaid_token = public_token
          $scope.create_bank_account(data)
      })
      handler.open()
    
    $scope.create_bank_account = (data) ->
      # data: { first_name, last_name, plaid_token, routing_number, account_number }
      $scope.is_loading = true

      $http.post("#{RENTAPPLICATION_API_URL}/api/v3/referrers/bank_account/", data )
      .then (resp) ->
        $scope.load_affiliate_referrer()
      .catch (err) ->
        console.log(err)
      .finally ->
        $scope.is_loading = false
    
    $scope.load_affiliate_referrer = () ->
      $http.get "#{RENTAPPLICATION_API_URL}/api/v3/referrers/"
      .then (resp) ->
        $scope.affiliate_referrer = resp.data.results[0]
      .catch (err) ->
        console.log(err)
    
    $scope.edit_bank_account = () ->
      $scope.is_loading = true
      


// WEBPACK FOOTER //
// ./components/dashboard/referral/referral.coffee